import { useState, useEffect } from 'react'; 
import { useStepContext } from "../../utils/StepContext.jsx"
import { useFormContext } from "../../utils/FormContext.jsx"
import { useAuth } from "../../utils/AuthContext/AuthContext.jsx"

import MainCard from "../MainCard.jsx";
import ProgressBar from "../ProgressBar/ProgressBar.jsx";
import SaveButton from "../SaveButton.jsx";
import PDFPreview from "../PDFPreview.jsx";
import HelpButton from '../HelpButton.jsx';
import ShishitoAssist from '../ShishitoAssist/ShishitoAssist.jsx';
import { useMediaQuery } from "react-responsive";

const ClosingCosts = () => {

    const { handleNext, handleBack } = useStepContext();
    const { formData, formId, handleClosingCostChange, handleClosingServicesFeeInputChange, setStandardSelections, resetFormData } = useFormContext(); 

    const currentPageValue = 2;
    const currentSubStepProgress = 4/7; 
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    const { token, user } = useAuth(); // Use user and token from context
    const [isAssistVisible, setIsAssistVisible] = useState(false);
    
    // console.log(formData);

    const toggleAssist = () => {
        setIsAssistVisible(!isAssistVisible);
    };

    const onNext = () => {
        handleNext();
    };

    return (
        <div className="w-full flex flex-col items-center">
        {/* <ProgressBar currentPage={currentPageValue} subStepProgress={currentSubStepProgress}/> */}
        <MainCard width={750} gap={0}>
            
            {/* CLOSING SERVICES FEE */}
            <div className="overflow-y-auto md:max-h-[425px] max-h-[45vh] w-full">
            <div className="inline-flex w-full justify-between mb-8">
            {isMobile ? <h3 className="text-black text-[18px] text-left font-normal font-['Inter']">Closing costs</h3> : <h3 className="text-black text-xl text-left font-normal font-['Inter']">Closing costs</h3>}
                <div className='h-auto gap-2 md:gap-4 items-center inline-flex'>
                    <HelpButton onClick={toggleAssist}/>
                    <SaveButton formData={formData} formId={formId}/>
                    {user && <PDFPreview formData={formData}/>}
                </div>
            </div>
            <div className="flex flex-col">

                {/* USE STANDARD OPTION */}
                <div className="flex flex-col justify-between mt-1 pl-2">
                    <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter] pr-4'>Do you want to fill the Closing Costs with the Standard Selections?</span>    
                    {/* <span className="w-[450px] h-auto text-shi-purple mb-3 text-xs font-['Inter']">Typically Split 50/50, this fee charged by a title company to file documents with the county recorder and officially close a deal. Ranges from $150-$250</span> */}
                </div>
                <div className="self-stretch justify-start gap-[25px] inline-flex items-center mb-5 pl-2">
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio"
                            id="standardClosingCostsYes" 
                            value="yes" 
                            checked={formData.standardClosingCosts === 'yes'} 
                            onChange={(e) => {
                                handleClosingCostChange('standardClosingCosts', e.target.value); 
                                setStandardSelections();    
                            }}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Yes</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="standardClosingCostsNo"
                            value="no" 
                            checked={formData.standardClosingCosts === 'no'} 
                            onChange={(e) => {
                                handleClosingCostChange('standardClosingCosts', e.target.value);
                                resetFormData(); 
                            }}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">No</label>
                    </div>
                </div>
                {(formData.standardClosingCosts === 'yes' || formData.standardClosingCosts === '') && (
                <div>
                    <div className="relative mb-6 mt-2 w-full border rounded-md border-slate-400 p-2.5">
                    <span className="absolute -top-2 left-2 bg-white px-1 text-[12px] md:text-sm font-[Inter] text-slate-700">STANDARD SELECTIONS</span>
                    {/* <span className="w-[450px] h-auto text-shi-purple mb-3 text-xs font-['Inter'] pl-2">Standard Selections:</span> */}
                    <div className="grid grid-cols-2 gap-4 pl-2 pt-2">
                        <div className="my-1.5">
                            <div className="mb-1.5 flex flex-col">
                                <span className="text-slate-600 text-sm">Closing Services</span>
                                <span>50/50 Buyer/Seller</span>
                            </div>
                            {/* <div className="mb-1.5 flex flex-col">
                                <span className="text-slate-600 text-sm">Status Letter</span>
                                <span>Seller</span>
                            </div> */}
                            <div className="mb-1.5 flex flex-col">
                                <span className="text-slate-600 text-sm">Record Change</span>
                                <span>Seller</span>
                            </div>
                            <div className="mb-1.5 flex flex-col">
                                <span className="text-slate-600 text-sm">Cost of Appraisal</span>
                                <span>Buyer</span>
                            </div>
                            <div className="mb-1.5 flex flex-col">
                                <span className="text-slate-600 text-sm">HOA Assessment</span>
                                <span>Defaults to Buyer</span>
                            </div>
                            <div className="mb-1.5 flex flex-col">
                                <span className="text-slate-600 text-sm">Other Fees</span>
                                <span>Seller</span>
                            </div>
                            <div className="mb-1.5 flex flex-col">
                                <span className="text-slate-600 text-sm">Local Transfer Tax</span>
                                <span>Seller</span>
                            </div>
                        </div>
                        <div className="my-1.5">
                            <div className="mb-1.5 flex flex-col">
                                <span className="text-slate-600 text-sm">Sales and Use Tax</span>
                                <span>Buyer</span>
                            </div>
                            <div className="mb-1.5 flex flex-col">
                                <span className="text-slate-600 text-sm">Private Transfer</span>
                                <span>Seller if transferring home ownership, else N/A</span>
                            </div>
                            <div className="mb-1.5 flex flex-col">
                                <span className="text-slate-600 text-sm">Water fees don't exceed $300 for:</span>
                                <span>Water District</span>
                            </div>
                            <div className="mb-1.5 flex flex-col">
                                <span className="text-slate-600 text-sm">Water Transfer</span>
                                <span>50/50 Buyer/Seller</span>
                            </div>
                            <div className="mb-1.5 flex flex-col">
                                <span className="text-slate-600 text-sm">Utility Transfer</span>
                                <span>Seller</span>
                            </div>
                            <div className="mb-1.5 flex flex-col">
                                <span className="text-slate-600 text-sm">Tax Certificate</span>
                                <span>N/A</span>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
                 )}

                {/* CLOSING SERVICES FEES */}
                {/* {formData.standardClosingCosts === 'no' && ( */}
                <>
                <div className="flex flex-col justify-between mt-5">
                    <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter]'>Closing Services Fee</span>    
                    <span className="w-full h-auto text-shi-purple mb-2 text-[13px] md:text-xs font-['Inter']">Typically Split 50/50, this fee charged by a title company to file documents with the county recorder and officially close a deal. Ranges from $150-$250</span>
                </div>
                <div className="self-stretch justify-between flex-wrap md:flex-none inline-flex items-center mb-8">
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio"
                            id="serviceFeeBuyer" 
                            value="buyer" 
                            checked={formData.closingServicesFee === 'buyer'} 
                            onChange={(e) => handleClosingCostChange('closingServicesFee', e.target.value)}
                            
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Buyer</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="serviceFeeSeller"
                            value="seller" 
                            checked={formData.closingServicesFee === 'seller'} 
                            onChange={(e) => handleClosingCostChange('closingServicesFee', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Seller</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="serviceFeeHalf"
                            value="half" 
                            checked={formData.closingServicesFee === 'half'} 
                            onChange={(e) => handleClosingCostChange('closingServicesFee', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">50/50 Buyer/Seller</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="serviceFeeOther"
                            value="other" 
                            checked={formData.closingServicesFee === 'other'} 
                            onChange={(e) => handleClosingCostChange('closingServicesFee', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Other (N/A)</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                                type="text"
                                name="closingServicesFeeOtherInput"
                                className="w-auto py-1 px-3 h-[39px] self-stretch text-left bg-white rounded-md border border-slate-300 justify-start items-center gap-2.5 flex"
                                placeholder="Other Input"
                                value={formData.closingServicesFeeOtherInput}
                                onChange={handleClosingServicesFeeInputChange}
                        />
                    </div>
                </div>
                </>
                {/* )} */}
            </div>

            {/* STATUS LETTER FEE */}

            {/* {formData.standardClosingCosts === 'no' && ( */}
            <>
            {/* <div className="flex flex-col">
                <div className="flex flex-col justify-between">
                    <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter]'>Status Letter Fee</span>
                    <span className="w-full h-auto text-shi-purple mb-2 text-[13px] md:text-xs font-['Inter']">Only applicable if in an HOA. Fee by HOA to provide info on Seller's account.</span>    
                </div>
                
                <div className="self-stretch justify-start flex-wrap gap-[10px] md:gap-[25px] mb-8 inline-flex items-center">
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio"
                            id="statusFeeBuyer" 
                            value="buyer" 
                            checked={formData.statusLetterFee === 'buyer'} 
                            onChange={(e) => handleClosingCostChange('statusLetterFee', e.target.value)}
                            
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Buyer</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="statusFeeSeller"
                            value="seller" 
                            checked={formData.statusLetterFee === 'seller'} 
                            onChange={(e) => handleClosingCostChange('statusLetterFee', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Seller</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="statusFeeHalf"
                            value="half" 
                            checked={formData.statusLetterFee === 'half'} 
                            onChange={(e) => handleClosingCostChange('statusLetterFee', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">50/50 Buyer/Seller</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="statusFeeNA"
                            value="n/a" 
                            checked={formData.statusLetterFee === 'n/a'} 
                            onChange={(e) => handleClosingCostChange('statusLetterFee', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">N/A</label>
                    </div>
                </div>
            </div> */}

            {/* RECORD CHANGE FEE */}

            <div className="flex flex-col">
                <div className="flex flex-col justify-between">
                    <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter]'>Record Change Fee</span>
                    <span className="w-[300px] md:w-[650px] h-auto text-shi-purple mb-2 text-[13px] md:text-xs font-['Inter']">(Typically Paid by Buyer) - Recording fees to clear all documents of record against the seller</span>    
                </div>
                
                <div className="self-stretch justify-start flex-wrap gap-[10px] md:gap-[25px] mb-8 inline-flex items-center">
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio"
                            id="recordChangeFeeBuyer" 
                            value="buyer" 
                            checked={formData.recordChangeFee === 'buyer'} 
                            onChange={(e) => handleClosingCostChange('recordChangeFee', e.target.value)}
                            
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Buyer</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="recordChangeFeeSeller"
                            value="seller" 
                            checked={formData.recordChangeFee === 'seller'} 
                            onChange={(e) => handleClosingCostChange('recordChangeFee', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Seller</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="recordChangeFeeHalf"
                            value="half" 
                            checked={formData.recordChangeFee === 'half'} 
                            onChange={(e) => handleClosingCostChange('recordChangeFee', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">50/50 Buyer/Seller</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="recordChangeFeeNA"
                            value="n/a" 
                            checked={formData.recordChangeFee === 'n/a'} 
                            onChange={(e) => handleClosingCostChange('recordChangeFee', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">N/A</label>
                    </div>
                </div>
            </div>

            {/* APPRAISAL FEE */}

            <div className="flex flex-col">
                <div className="flex flex-col justify-between">
                    <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter]'>Cost of Appraisal</span>
                    <span className="w-[300px] md:w-[650px] h-auto text-shi-purple mb-2 text-[13px] md:text-xs font-['Inter']">(Typically Paid by Buyer) - Used by the Title Company</span>    
                </div>
                
                <div className="self-stretch justify-start flex-wrap gap-[10px] md:gap-[25px] mb-8 inline-flex items-center">
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio"
                            id="appraisalFeeBuyer" 
                            value="buyer" 
                            checked={formData.appraisalFee === 'buyer'} 
                            onChange={(e) => handleClosingCostChange('appraisalFee', e.target.value)}
                            
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Buyer</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="appraisalFeeSeller"
                            value="seller" 
                            checked={formData.appraisalFee === 'seller'} 
                            onChange={(e) => handleClosingCostChange('appraisalFee', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Seller</label>
                    </div>
                </div>
            </div>

            {/* ASSESSMENT FEES */}

            <div className="flex flex-col">
                <div className="flex flex-col justify-between">
                    <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter]'>Assessment Fees</span>
                    <span className="w-[300px] md:w-[650px] h-auto text-shi-purple mb-2 text-[13px] md:text-xs font-['Inter']">Only applicable if property is in a HOA. Buyer may need to pay HOA for reserves or working capital</span>    
                </div>
                
                <div className="self-stretch justify-start flex-wrap gap-[10px] md:gap-[25px] mb-8 inline-flex items-center">
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio"
                            id="assessmentFeeBuyer" 
                            value="buyer" 
                            checked={formData.assessmentFee === 'buyer'} 
                            onChange={(e) => handleClosingCostChange('assessmentFee', e.target.value)}
                            
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Buyer</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="assessmentFeeSeller"
                            value="seller" 
                            checked={formData.assessmentFee === 'seller'} 
                            onChange={(e) => handleClosingCostChange('assessmentFee', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Seller</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="assessmentFeeHalf"
                            value="half" 
                            checked={formData.assessmentFee === 'half'} 
                            onChange={(e) => handleClosingCostChange('assessmentFee', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">50/50 Buyer/Seller</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="assessmentFeeNA"
                            value="n/a" 
                            checked={formData.assessmentFee === 'n/a'} 
                            onChange={(e) => handleClosingCostChange('assessmentFee', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">N/A</label>
                    </div>
                </div>
            </div>

            {/* OTHER FEE */}

            <div className="flex flex-col">
            <div className="flex flex-col justify-between">
                <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter]'>Other Fees</span>
                    <span className="w-[300px] md:w-[650px] h-auto text-shi-purple mb-2 text-[13px] md:text-xs font-['Inter']">Any other fees listed in Status Letter, typically N/A</span>
                </div>
                
                <div className="self-stretch justify-start flex-wrap gap-[10px] md:gap-[25px] mb-8 inline-flex items-center">
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio"
                            id="otherFeeBuyer" 
                            value="buyer" 
                            checked={formData.otherFee === 'buyer'} 
                            onChange={(e) => handleClosingCostChange('otherFee', e.target.value)}
                            
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Buyer</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="otherFeeSeller"
                            value="seller" 
                            checked={formData.otherFee === 'seller'} 
                            onChange={(e) => handleClosingCostChange('otherFee', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Seller</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="otherFeeHalf"
                            value="half" 
                            checked={formData.otherFee === 'half'} 
                            onChange={(e) => handleClosingCostChange('otherFee', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">50/50 Buyer/Seller</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="otherFeeOther"
                            value="n/a" 
                            checked={formData.otherFee === 'n/a'} 
                            onChange={(e) => handleClosingCostChange('otherFee', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">N/A</label>
                    </div>
                </div>
            </div>  

            {/* LOCAL TRANSFER TAX */}

            <div className="flex flex-col">
                <div className="flex flex-col justify-between">
                    <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter]'>Local Transfer Tax</span>
                    <span className="w-[300px] md:w-[650px] h-auto text-shi-purple mb-2 text-[13px] md:text-xs font-['Inter']">Charged when title of a property is transferred from one owner to another</span>
                </div>
                
                <div className="self-stretch justify-start flex-wrap gap-[10px] md:gap-[25px] mb-8 inline-flex items-center">
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio"
                            id="transferTaxBuyer" 
                            value="buyer" 
                            checked={formData.transferTax === 'buyer'} 
                            onChange={(e) => handleClosingCostChange('transferTax', e.target.value)}
                            
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Buyer</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="transferTaxSeller"
                            value="seller" 
                            checked={formData.transferTax === 'seller'} 
                            onChange={(e) => handleClosingCostChange('transferTax', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Seller</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="transferTaxHalf"
                            value="half" 
                            checked={formData.transferTax === 'half'} 
                            onChange={(e) => handleClosingCostChange('transferTax', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">50/50 Buyer/Seller</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="transferTaxOther"
                            value="n/a" 
                            checked={formData.transferTax === 'n/a'} 
                            onChange={(e) => handleClosingCostChange('transferTax', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">N/A</label>
                    </div>
                </div>
            </div>

            {/* SALES AND USE TAX */}

            <div className="flex flex-col">
                <div className="flex flex-col justify-between">
                    <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter]'>Sales and Use Tax</span>
                    <span className="w-[300px] md:w-[650px] h-auto text-shi-purple mb-2 text-[13px] md:text-xs font-['Inter']">Sales and Use Taxes that may occur because of this transaction</span>
                </div>
                
                <div className="self-stretch justify-start flex-wrap gap-[10px] md:gap-[25px] mb-8 inline-flex items-center">
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio"
                            id="salesAndUseTaxBuyer" 
                            value="buyer" 
                            checked={formData.salesAndUseTax === 'buyer'} 
                            onChange={(e) => handleClosingCostChange('salesAndUseTax', e.target.value)}
                            
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Buyer</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="salesAndUseTaxSeller"
                            value="seller" 
                            checked={formData.salesAndUseTax === 'seller'} 
                            onChange={(e) => handleClosingCostChange('salesAndUseTax', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Seller</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="salesAndUseTaxHalf"
                            value="half" 
                            checked={formData.salesAndUseTax === 'half'} 
                            onChange={(e) => handleClosingCostChange('salesAndUseTax', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">50/50 Buyer/Seller</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="salesAndUseTaxNA"
                            value="n/a" 
                            checked={formData.salesAndUseTax === 'n/a'} 
                            onChange={(e) => handleClosingCostChange('salesAndUseTax', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">N/A</label>
                    </div>
                </div>
            </div>

            {/* PRIVATE TRANSFER FEE */}

            <div className="flex flex-col">
                <div className="flex flex-col justify-between">
                    <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter]'>Private Transfer Fee</span>
                    <span className="w-[300px] md:w-[650px] h-auto text-shi-purple mb-2 text-[13px] md:text-xs font-['Inter']">Leave N/A. Only applicable if private transfer of property is taking place</span>
                </div>
                
                <div className="self-stretch justify-start flex-wrap gap-[10px] md:gap-[25px] mb-8 inline-flex items-center">
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio"
                            id="privateTransferFeeBuyer" 
                            value="buyer" 
                            checked={formData.privateTransferFee === 'buyer'} 
                            onChange={(e) => handleClosingCostChange('privateTransferFee', e.target.value)}
                            
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Buyer</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="privateTransferFeeSeller"
                            value="seller" 
                            checked={formData.privateTransferFee === 'seller'} 
                            onChange={(e) => handleClosingCostChange('privateTransferFee', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Seller</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="privateTransferFeeHalf"
                            value="half" 
                            checked={formData.privateTransferFee === 'half'} 
                            onChange={(e) => handleClosingCostChange('privateTransferFee', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">50/50 Buyer/Seller</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="privateTransferFeeNA"
                            value="n/a" 
                            checked={formData.privateTransferFee === 'n/a'} 
                            onChange={(e) => handleClosingCostChange('privateTransferFee', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">N/A</label>
                    </div>
                </div>
            </div>

                        {/* WATER TRANSFER FEE */}

            <div className="flex flex-col">
                <div className="flex flex-col justify-between">
                    <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter]'>Water Transfer Fee</span>
                    <span className="w-[300px] md:w-[650px] h-auto text-shi-purple mb-2 text-[13px] md:text-xs font-['Inter']">Fee that is charged to transfer water accounts from the seller to the buyer after a closing, typically paid by seller.</span>
                </div>

                {/* WATER TYPE */}
                <div className="self-stretch justify-start flex-wrap mb-8 flex flex-col">
                    <div className="flex flex-col gap-4 w-full">
                        <div className="items-center gap-2 flex flex-wrap">
                            <label className='text-[14px] text-slate-600 font-[Inter] pr-2'>Water Fees to date do not exceed:</label>
                            <div className="w-[40vh] py-1 px-3 h-[30px] md:h-[39px] self-stretch text-left bg-white rounded-md border border-slate-300 justify-start items-center gap-2.5 flex">
                            <div className=" text-slate-500 font-semibold font-['Inter']">$</div>
                            <input 
                                    type="text"
                                    name="waterTransferFeeAmount"
                                    className="text-left pl-2 w-full"
                                    placeholder="Other Input"
                                    value={formData.waterTransferFeeAmount}
                                    onChange={handleClosingServicesFeeInputChange}
                            />
                            </div>
                        </div>
                        
                        <div className="inline-flex w-full justify-start gap-[15px]">
                            <div className="items-center gap-2 flex">
                                <input 
                                    type="checkbox"
                                    id="waterStockCert" 
                                    value={formData.waterStockCert}
                                    checked={formData.waterStockCert === 'yes'} 
                                    onChange={(e) => handleClosingCostChange('waterStockCert', e.target.checked ? 'yes' : 'no')}
                                />
                                <label className="text-black text-opacity-60 font-semibold font-['Inter'] text-[14px]">Water Stock / Certificates</label>
                            </div>
                            <div className="items-center gap-2 flex">
                                <input 
                                    type="checkbox" 
                                    id="waterDistrict"
                                    value={formData.waterDistrict}
                                    checked={formData.waterDistrict === 'yes'} 
                                    onChange={(e) => handleClosingCostChange('waterDistrict', e.target.checked ? 'yes' : 'no')}
                                />
                                <label className="text-black text-opacity-60 font-semibold font-['Inter'] text-[14px]">Water District</label>
                            </div>
                        </div>
                        <div className="inline-flex w-full justify-start gap-[15px]">
                            <div className="items-center gap-2 flex">
                                <input 
                                    type="checkbox" 
                                    id="augmentationMembership"
                                    value={formData.augmentationMembership}
                                    checked={formData.augmentationMembership === 'yes'} 
                                    onChange={(e) => handleClosingCostChange('augmentationMembership', e.target.checked ? 'yes' : 'no')}
                                />
                                <label className="text-black text-opacity-60 font-semibold font-['Inter'] text-[14px]">Augmentation Membership</label>
                            </div>
                            <div className="items-center gap-2 flex">
                                <input 
                                    type="checkbox" 
                                    id="smallDomesticWaterCo"
                                    value={formData.smallDomesticWaterCo}
                                    checked={formData.smallDomesticWaterCo === 'yes'} 
                                    onChange={(e) => handleClosingCostChange('smallDomesticWaterCo', e.target.checked ? 'yes' : 'no')}
                                />
                                <label className="text-black text-opacity-60 font-semibold font-['Inter'] text-[14px]">Small Domestic Water Co.</label>
                            </div>
                        </div>
                        <div className="inline-flex w-full justify-start gap-[15px]">
                            <div className="items-center gap-2 flex">
                                <input 
                                    type="checkbox" 
                                    id="waterTransferFeeOther"
                                    value={formData.waterTransferFeeOther}
                                    checked={formData.waterTransferFeeOther === 'yes'} 
                                    onChange={(e) => handleClosingCostChange('waterTransferFeeOther', e.target.checked ? 'yes' : 'no')}
                                />
                                <label className="text-black text-opacity-60 font-semibold font-['Inter'] text-[14px]">Other</label>
                            </div>
                            <div className="items-center gap-2 flex">
                                <input 
                                        type="text"
                                        name="waterTransferFeeOtherText"
                                        className="w-full py-1 px-3 h-[39px] self-stretch text-left bg-white rounded-md border border-slate-300 justify-start items-center gap-2.5 flex"
                                        placeholder="Other Input"
                                        value={formData.waterTransferFeeOtherText}
                                        onChange={handleClosingServicesFeeInputChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* WHO PAYS FOR WATER TRANSFER FEE */}
                <div className="self-stretch justify-start flex-wrap gap-[10px] md:gap-[25px] mb-8 inline-flex items-center">
                    <div className="flex flex-col">
                        <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter]'>Water Fees to be Paid By:</span>
                        <div className="inline-flex flex-wrap gap-[10px] md:gap-[25px]">
                            <div className="items-center gap-2 flex">
                                <input 
                                    type="radio"
                                    id="waterTransferBuyer" 
                                    value="buyer" 
                                    checked={formData.waterTransferFee === 'buyer'} 
                                    onChange={(e) => handleClosingCostChange('waterTransferFee', e.target.value)}
                                />
                                <label className="text-black text-opacity-60 font-semibold font-['Inter']">Buyer</label>
                            </div>
                            <div className="items-center gap-2 flex">
                                <input 
                                    type="radio" 
                                    id="waterTransferSeller"
                                    value="seller" 
                                    checked={formData.waterTransferFee === 'seller'} 
                                    onChange={(e) => handleClosingCostChange('waterTransferFee', e.target.value)}
                                />
                                <label className="text-black text-opacity-60 font-semibold font-['Inter']">Seller</label>
                            </div>
                            <div className="items-center gap-2 flex">
                                <input 
                                    type="radio" 
                                    id="waterTransferHalf"
                                    value="half" 
                                    checked={formData.waterTransferFee === 'half'} 
                                    onChange={(e) => handleClosingCostChange('waterTransferFee', e.target.value)}
                                />
                                <label className="text-black text-opacity-60 font-semibold font-['Inter']">50/50 Buyer/Seller</label>
                            </div>
                            <div className="items-center gap-2 flex">
                                <input 
                                    type="radio" 
                                    id="waterTransferOther"
                                    value="n/a" 
                                    checked={formData.waterTransferFee === 'n/a'} 
                                    onChange={(e) => handleClosingCostChange('waterTransferFee', e.target.value)}
                                />
                                <label className="text-black text-opacity-60 font-semibold font-['Inter']">N/A</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* UTILITY TRANSFER FEE */}

            <div className="flex flex-col">
                <div className="flex flex-col justify-between">
                    <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter]'>Utility Transfer Fee</span>
                    <span className="w-[300px] md:w-[650px] h-auto text-shi-purple mb-2 text-[13px] md:text-xs font-['Inter']">Fee that is charged to transfer utilities accounts from the seller to the buyer after a closing, typically paid by buyer.</span>
                </div>
                
                <div className="self-stretch justify-start flex-wrap gap-[10px] md:gap-[25px] mb-8 inline-flex items-center">
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio"
                            id="utilityTransferBuyer" 
                            value="buyer" 
                            checked={formData.utilityTransferFee === 'buyer'} 
                            onChange={(e) => handleClosingCostChange('utilityTransferFee', e.target.value)}
                            
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Buyer</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="utilityTransferSeller"
                            value="seller" 
                            checked={formData.utilityTransferFee === 'seller'} 
                            onChange={(e) => handleClosingCostChange('utilityTransferFee', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Seller</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="utilityTransferHalf"
                            value="half" 
                            checked={formData.utilityTransferFee === 'half'} 
                            onChange={(e) => handleClosingCostChange('utilityTransferFee', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">50/50 Buyer/Seller</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="utilityTransferOther"
                            value="n/a" 
                            checked={formData.utilityTransferFee === 'n/a'} 
                            onChange={(e) => handleClosingCostChange('utilityTransferFee', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">N/A</label>
                    </div>
                </div>
            </div>

            {/* TAX CERT FEE */}

            <div className="flex flex-col">
                <div className="flex flex-col justify-between">
                    <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter]'>Tax Certificate</span>
                    <span className="w-[300px] md:w-[650px] h-auto text-shi-purple mb-2 text-[13px] md:text-xs font-['Inter']">Typically left blank. A Tax Cert lists any special taxing districts that affect the property.</span>
                </div>
                
                <div className="self-stretch justify-start flex-wrap gap-[10px] md:gap-[25px] mb-8 inline-flex items-center">
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio"
                            id="taxCertFee" 
                            value="buyer" 
                            checked={formData.taxCertFee === 'buyer'} 
                            onChange={(e) => handleClosingCostChange('taxCertFee', e.target.value)}
                            
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Buyer</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="taxCertFee"
                            value="seller" 
                            checked={formData.taxCertFee === 'seller'} 
                            onChange={(e) => handleClosingCostChange('taxCertFee', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Seller</label>
                    </div>
                </div>
            </div> 
        </>
        {/* )} */}
            </div>
            {/* BOTTOM BUTTONS */}
          
            <div className="flex w-full justify-center gap-10 md:gap-36 mt-2 bg-white">
                <button className="w-[100px] md:w-[150px] justify-center text-center text-shi-green bg-white border-white text-[16px] md:text-lg font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-slate-200 items-center md:items-start flex" onClick={handleBack}>
                    Back
                </button>
                <button className="w-[100px] md:w-[150px] justify-center items-center text-center text-white bg-shi-green text-[16px] md:text-lg font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-green-950 md:items-start flex" onClick={onNext}>
                    Next
                </button>
            </div>
                
        </MainCard>
        {isAssistVisible && (
                <div className="w-full md:w-auto absolute bottom-1 md:right-4">
                    <ShishitoAssist onClose={toggleAssist}/>
                </div>
            )}
        </div>
        
    )
}

export default ClosingCosts; 